import { GetUsersBasedOnPermissions } from '@carrier-sce-sharedpackages/reactauthwrapper';

export const getUsersFromPermission = () => {
  return new Promise((resolve, reject) => {
    GetUsersBasedOnPermissions(
      process.env.REACT_APP_UM_apiUrl,
      {
        Permission: process.env.REACT_APP_UM_PERMISSION_NAME,
        GroupInfo: false,
        UserActivityInfo: false,
      },
      (res) => {
        let orderedUsersArray = res.usersDetails.sort((a, b) => {
          return a.firstName < b.firstName
            ? -1
            : a.firstName > b.firstName
            ? 1
            : 0;
        });

        resolve(orderedUsersArray);
      },
      (ex) => {
        console.log(
          `Failed fetching users based on the application permission. Exception as follow: `,
          ex,
        );
        reject(ex);
      },
    );
  });
};
